import React from 'react';
import NavBar from './Nav'; // Assuming you have a NavBar component
import './portfolio.css'; // Assuming you have a Portfolio.css file for styling
import AliImage from './images/gulu.jpg';
// import RaoImage from './images/rao.jpg';
import ZakiaImage from './images/zaku.jpg';

const Portfolio = () => {
  return (
    <>
      {/* Include the NavBar component */}
      <NavBar />

      {/* Main content for the portfolio */}
      <div className="portfolio-container">
        {/* Ali Ahmad Section */}
        <div className="portfolio-section">
          <img src={AliImage} alt="Ali Ahmad" className="portfolio-image" />
          <h2>Mr. Ali Ahmad</h2>
          <p>CEO</p>
        </div>

        {/* Rao Fahad Ali Section */}
        <div className="portfolio-section">
          {/* <img src={RaoImage} alt="Rao Fahad Ali" className="portfolio-image" /> */}
          <h2>Rao Fahad Ali</h2>
          <p>Section Head / IT Instructor and Web Developer</p>
        </div>

        {/* Zakia Maharvi Section */}
        <div className="portfolio-section">
          <img src={ZakiaImage} alt="Zakia Maharvi" className="portfolio-image" />
          <h2>Zakia Maharvi</h2>
          <p>Section Head of Academy Section</p>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
